import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  getShowBagBanner,
  bagBannerShown
} from "@template/state/modules/infoBanner";

import ReservationMessage from "./ReservationMessage";

const mapStateToProps = state => ({
  showBagBanner: getShowBagBanner(state)
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ bagBannerShown }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ReservationMessage);
